import { getDateFromOffset, getDate } from "../../../utils/convert-date";

export const MAP_PROJECT_Count_Summary_MockData = [
  { StatusCount: 1, Status: "IN-PROGRESS" },
  { StatusCount: 0, Status: "COMPLETE" },
];

const fromDate = getDateFromOffset(getDate(), -210);
const toDate = getDateFromOffset(getDate(), 180);

export const MAP_PROJECT_LIST_MOCKDATA = {
  Items: [
    {
      Description: "Description",
      FromDate: fromDate,
      MPENumber: "MPE1234567",
      MapCreditsDisbursed: "10580",
      MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
      MigrationTags: {
        "aws-migration-project-id": "MPE1234567",
      },
      Name: "ACME On-Prem to AWS 2023",
      Scope: [
        {
          AccountName: "Sandbox Account",
          AccountNumber: "700953207471",
          AccountType: "MEMBER",
        },
        {
          AccountName: "Security Account",
          AccountNumber: "612020440690",
          AccountType: "MEMBER",
        },
      ],
      Status: "IN-PROGRESS",
      TaggedCost: "52900",
      ToDate: toDate,
      UntaggedCost: "63000",
    },
  ],
};

export const MAP_PROJECT_DETAILS_MOCKDATA = {
  MapProjectDetails: {
    CostUpdatedAt: getDateFromOffset(getDate(), -1),
    CreatedBy: "08ccebd4-f4a0-4ba2-97e8-40638c9426a2",
    CreatedOn: "2023-06-08 09:22:55",
    CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
    Description: "Description",
    EnforceTags: false,
    FromDate: fromDate,
    MPENumber: "MPE1234567",
    MapCreditsDisbursed: "10580",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    MigrationTags: {
      "aws-migration-project-id": "MPE1234567",
    },
    ModifiedBy: "08ccebd4-f4a0-4ba2-97e8-40638c9426a2",
    ModifiedOn: "2023-06-08 09:22:55",
    Name: "ACME On-Prem to AWS 2023",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    ProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ScopeSelector: "mgmt_account",
    ScopeSelectorId: "855075416228",
    Status: "IN-PROGRESS",
    ProjectCostTagged: "52900",
    ToDate: toDate,
    ProjectCostUntagged: "63000",
  },
  MapProjectScope: [
    {
      AccountName: "Sandbox Account",
      AccountNumber: "700953207471",
      AccountType: "MEMBER",
      CreatedBy: "08ccebd4-f4a0-4ba2-97e8-40638c9426a2",
      CreatedOn: "2023-06-08 09:22:55",
      CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
      ID: "0b675a3b-aebe-476f-9ed1-9ae9fccec78e",
      MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    },
    {
      AccountName: "Security Account",
      AccountNumber: "612020440690",
      AccountType: "MEMBER",
      CreatedBy: "08ccebd4-f4a0-4ba2-97e8-40638c9426a2",
      CreatedOn: "2023-06-08 09:22:55",
      CustomerId: "23229912-3180-4132-bcae-9c54c1a054cf",
      ID: "f0fdac68-8833-4c2a-803f-12b9a332d704",
      MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    },
  ],
};
